import { observer } from 'mobx-react-lite'
import { type InventoryManagerViewModel } from '@/features/inventory/admin/InventoryManagerViewModel'
import { InventoryTable } from '@/features/inventory/admin/components/InventoryTable'
import { InventoryRowContainer } from '@/features/inventory/admin/components/InventoryRow/InventoryRowContainer'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'

export interface InventoryTableContainerProps {
  vm: InventoryManagerViewModel
}

export const InventoryTableContainer = observer(
  function InventoryTableContainer({ vm }: InventoryTableContainerProps) {
    const scrollProvider = vm.searcher.scrollProvider

    return (
      <InventoryTable
        columns={vm.columns.map((col) => ({
          id: col.id,
          header: col.header,
          align: col.align,
        }))}
        loader={
          !scrollProvider.isDone && (
            <InfiniteScrollLoaderContainer scrollProvider={scrollProvider} />
          )
        }
      >
        {vm.itemVms.map((itemVm) => (
          <InventoryRowContainer
            key={itemVm.inventoryItem.id}
            vm={itemVm}
            columns={vm.columns}
          />
        ))}
      </InventoryTable>
    )
  },
)
